"use strict";
'use es6';

var _interopRequireWildcard = require("@babel/runtime/helpers/interopRequireWildcard");

var _interopRequireDefault = require("@babel/runtime/helpers/interopRequireDefault");

Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.default = void 0;

var _objectWithoutProperties2 = _interopRequireDefault(require("@babel/runtime/helpers/objectWithoutProperties"));

var _extends2 = _interopRequireDefault(require("@babel/runtime/helpers/extends"));

var _react = _interopRequireWildcard(require("react"));

var _classNames = _interopRequireDefault(require("react-utils/classNames"));

var _devLogger = _interopRequireDefault(require("react-utils/devLogger"));

var _I18n = _interopRequireDefault(require("I18n"));

var _Controllable = _interopRequireDefault(require("../decorators/Controllable"));

var _UISelect = _interopRequireDefault(require("../input/UISelect"));

var _virtualizedMenuRenderer = _interopRequireDefault(require("../input/utils/virtualizedMenuRenderer"));

var _UITypeaheadResultsItem = _interopRequireDefault(require("../typeahead/results/UITypeaheadResultsItem"));

var _createLazyPropType = _interopRequireDefault(require("../utils/propTypes/createLazyPropType"));

var _tshirtSize = require("../utils/propTypes/tshirtSize");

var MINUTES_IN_A_DAY = 24 * 60;
var NUMBER_REGEX = /\d/;

var condense = function condense(str) {
  return str.replace(/\s/g, '').toLowerCase();
};

var optionMatchesSearch = function optionMatchesSearch(option, search) {
  if (!search) {
    return true;
  } // Ignore whitespace and casing


  var condensedSearch = condense(search);
  var condensedOptionText = condense(option.text); // Match front-to-back, allowing chars to be skipped (except the first
  // number). So e.g. a search for "8" matches all times of the form "8:xx",
  // and a search for "815" matches "8:15 AM" and "8:15 PM".

  var searchRegexMatch = condensedSearch.match(NUMBER_REGEX);

  if (searchRegexMatch && searchRegexMatch[0] !== option.text.match(NUMBER_REGEX)[0]) {
    return false;
  }

  var lastSearchCharMatchPos = -1;

  for (var i = 0; i < condensedSearch.length; i++) {
    var searchCharMatchPos = condensedOptionText.indexOf(condensedSearch[i], lastSearchCharMatchPos + 1);

    if (searchCharMatchPos === -1) {
      return false;
    }

    lastSearchCharMatchPos = searchCharMatchPos;
  }

  return true;
};

var getSearchResults = function getSearchResults(options, search) {
  var filteredOptions = options.filter(function (option) {
    return optionMatchesSearch(option, search);
  });
  var exactMatches = [];
  var otherMatches = [];
  filteredOptions.forEach(function (option) {
    if (condense(option.text).startsWith(condense(search))) {
      exactMatches.push(option);
    } else {
      otherMatches.push(option);
    }
  });
  return [].concat(exactMatches, otherMatches);
};

var UITimePicker = _react.default.createClass({
  displayName: "UITimePicker",
  propTypes: {
    clearable: _react.PropTypes.bool.isRequired,
    extraTimes: _react.PropTypes.arrayOf(_react.PropTypes.number).isRequired,
    format: _react.PropTypes.string.isRequired,
    interval: _react.PropTypes.number.isRequired,
    maxValue: _react.PropTypes.number,
    minValue: _react.PropTypes.number,
    onChange: _react.PropTypes.func,
    placeholder: (0, _createLazyPropType.default)(_react.PropTypes.node).isRequired,
    size: _react.PropTypes.oneOfType([(0, _tshirtSize.propTypeForSizes)(['sm']), _react.PropTypes.oneOf(['default'])]).isRequired,
    use: _react.PropTypes.oneOf(['default', 'on-dark']).isRequired,
    value: _react.PropTypes.oneOfType([_react.PropTypes.number, _react.PropTypes.string])
  },
  getDefaultProps: function getDefaultProps() {
    return {
      clearable: true,
      extraTimes: [],
      format: 'LT',
      interval: 30,
      placeholder: function placeholder() {
        return _I18n.default.text('salesUI.UITimePicker.placeholder');
      },
      size: 'default',
      use: 'default'
    };
  },
  getInitialState: function getInitialState() {
    return {
      options: null
    };
  },
  componentWillMount: function componentWillMount() {
    var _this$props = this.props,
        extraTimes = _this$props.extraTimes,
        format = _this$props.format,
        interval = _this$props.interval,
        maxValue = _this$props.maxValue,
        minValue = _this$props.minValue,
        value = _this$props.value;
    var normalizedValue = this.normalizeValue({
      format: format,
      value: value
    });
    this.setState({
      options: this.generateOptions({
        extraTimes: extraTimes,
        format: format,
        interval: interval,
        maxValue: maxValue,
        minValue: minValue
      }, {
        normalizedValue: normalizedValue
      })
    });
  },
  componentWillReceiveProps: function componentWillReceiveProps(nextProps) {
    var extraTimes = nextProps.extraTimes,
        format = nextProps.format,
        interval = nextProps.interval,
        maxValue = nextProps.maxValue,
        minValue = nextProps.minValue,
        value = nextProps.value;

    if (extraTimes !== this.props.extraTimes || format !== this.props.format || interval !== this.props.interval || maxValue !== this.props.maxValue || minValue !== this.props.minValue || value !== this.props.value) {
      var normalizedValue = this.normalizeValue({
        format: format,
        value: value
      });
      this.setState({
        options: this.generateOptions({
          extraTimes: extraTimes,
          format: format,
          interval: interval,
          maxValue: maxValue,
          minValue: minValue
        }, {
          normalizedValue: normalizedValue
        })
      });
    }
  },
  focus: function focus() {
    if (this._timeInputRef) {
      this._timeInputRef.focus();
    }
  },
  formatTime: function formatTime(_ref) {
    var format = _ref.format,
        value = _ref.value;
    return _I18n.default.moment.utc(0).minutes(value).format(format);
  },
  generateOptions: function generateOptions(_ref2, _ref3) {
    var _this = this;

    var extraTimes = _ref2.extraTimes,
        format = _ref2.format,
        interval = _ref2.interval,
        maxValue = _ref2.maxValue,
        minValue = _ref2.minValue;
    var normalizedValue = _ref3.normalizedValue;
    var options = [];
    var min = typeof minValue === 'number' ? minValue : 0;
    var max = typeof maxValue === 'number' ? maxValue : MINUTES_IN_A_DAY;

    for (var value = 0; value < MINUTES_IN_A_DAY; value += interval) {
      var outOfRange = min > value || value > max;

      if (outOfRange) {
        continue;
      }

      var text = this.formatTime({
        format: format,
        value: value
      });
      options.push({
        text: text,
        value: value
      });

      if (normalizedValue && normalizedValue > value && normalizedValue < value + interval) {
        var normalizedValueText = _I18n.default.moment.utc(0).minutes(normalizedValue).format(format);

        options.push({
          text: normalizedValueText,
          value: normalizedValue
        });
      }
    }

    extraTimes.forEach(function (value) {
      if (!options.some(function (option) {
        return option.value === value;
      })) {
        var _text = _this.formatTime({
          format: format,
          value: value
        });

        options.push({
          text: _text,
          value: value
        });
      }
    });
    return options;
  },
  normalizeValue: function normalizeValue(_ref4) {
    var format = _ref4.format,
        value = _ref4.value;

    // Return a string corresponding to the number of minutes into the day
    // represented by the value.
    if (value == null) {
      return null;
    }

    if (typeof value === 'number') {
      return value;
    }

    _devLogger.default.warn({
      message: "UITimePicker: String value \"" + value + "\" given. This can cause inconsistent behavior.",
      key: 'UITimePicker: string value'
    });

    var moment = _I18n.default.moment.utc(value, format);

    return moment.hours() * 60 + moment.minutes();
  },
  valueRenderer: function valueRenderer(option) {
    return _react.default.createElement(_UITypeaheadResultsItem.default, {
      "aria-invalid": option.invalid,
      itemComponent: "span",
      option: (0, _extends2.default)({}, option, {
        icon: 'time'
      }),
      _useButton: false,
      _useDropdownText: false
    });
  },
  getButtonSize: function getButtonSize(_ref5) {
    var longhandSize = _ref5.longhandSize,
        use = _ref5.use;

    if (longhandSize === 'small' && use === 'on-dark') {
      return 'small';
    }

    return 'default';
  },
  getButtonUse: function getButtonUse(_ref6) {
    var longhandSize = _ref6.longhandSize,
        use = _ref6.use;

    if (longhandSize === 'default') {
      return 'form';
    } // Small size


    if (use === 'default') {
      return 'link';
    } // Small + on-dark


    return 'tertiary-light';
  },
  render: function render() {
    var _this2 = this;

    var _this$props2 = this.props,
        className = _this$props2.className,
        format = _this$props2.format,
        __interval = _this$props2.interval,
        size = _this$props2.size,
        use = _this$props2.use,
        value = _this$props2.value,
        rest = (0, _objectWithoutProperties2.default)(_this$props2, ["className", "format", "interval", "size", "use", "value"]);
    var longhandSize = (0, _tshirtSize.toLonghandSize)(size);
    var buttonSize = this.getButtonSize({
      longhandSize: longhandSize,
      use: use
    });
    var buttonUse = this.getButtonUse({
      longhandSize: longhandSize,
      use: use
    });
    return _react.default.createElement(_UISelect.default, (0, _extends2.default)({}, rest, {
      buttonSize: buttonSize,
      buttonUse: buttonUse,
      className: (0, _classNames.default)('private-timepicker', className, {
        'private-form__control--on-dark': use === 'on-dark'
      }),
      filterOptions: getSearchResults,
      matchPos: "start",
      matchProp: "label",
      menuRenderer: _virtualizedMenuRenderer.default,
      menuWidth: longhandSize === 'small' ? 300 : undefined,
      options: this.state.options,
      ref: function ref(elt) {
        _this2._timeInputRef = elt;
      },
      resetValue: null,
      value: this.normalizeValue({
        format: format,
        value: value
      }),
      valueRenderer: this.valueRenderer
    }));
  }
});

var _default = (0, _Controllable.default)(UITimePicker);

exports.default = _default;
module.exports = exports.default;